<template>
  <sui-form>
    <div>Outstanding balance: {{ formatAsPrice(amount.balance) }}</div>
    <br />
    <sui-form-field>
      <label>Amount paid</label>
      <vue-number name="amount" v-model="amount.amount" v-bind="priceFormat" />
    </sui-form-field>
    <sui-form-field>
      <label>Date of payment</label>
      <input placeholder="Date" name="date" type="date" v-model="amount.date" />
    </sui-form-field>
    <div v-if="error" class="ui negative message">
      <p>{{ error }}</p>
    </div>
    <sui-button type="button" positive icon="plus" v-on:click="submit">
      Pay
    </sui-button>
  </sui-form>
</template>

<script>
// eslint-disable-next-line import/no-extraneous-dependencies
import { component as VueNumber } from '@coders-tm/vue-number-format';

export default {
  name: 'PayInvoiceForm',
  components: {
    VueNumber,
  },
  props: ['amount', 'error'],
  data() {
    return {
      priceFormat: {
        decimal: '.',
        separator: ',',
        prefix: '€',
        precision: 2,
        masked: false,
        min: 0,
      },
    };
  },
  methods: {
    formatAsPrice(value) {
      const formattedNumber = value.toFixed(2);
      const [integerPart, decimalPart] = formattedNumber.split('.');

      const formattedInteger = parseInt(integerPart, 10).toLocaleString(
        undefined,
        {
          minimumFractionDigits: 0,
          maximumFractionDigits: 0,
        },
      );

      return `€${formattedInteger}${decimalPart ? '.' : ''}${decimalPart || ''
        }`;
    },
    reset() {
      this.$validator.reset();
    },
    fieldClass(name) {
      const result = [];
      if (this.errors.first(name)) {
        result.push('error');
      }
      return result;
    },
    submit() {
      this.$validator.validate().then((result) => {
        if (result) {
          this.$emit('saved');
        }
      });
    },
  },
  created() { },
};
</script>



// WEBPACK FOOTER //
// src/components/invoices/PayInvoiceForm.vue